import { UpdateProfileForm } from "./UpdateProfileForm";

export function ProfileContainer() {
  return (
    <div className="widget-content" style={{ paddingTop: '30px' }}>
      <UpdateProfileForm />
    </div>
  )
}